import { AnimatePresence, motion } from 'framer-motion';
import { ElementType } from 'react';
import styled from 'styled-components';
const IconCheckMark = ({ size }: any) => (
  <svg
    width={size ?? '10'}
    height={size ?? '10'}
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0.690491 4.87199C1.11173 4.38377 1.86262 4.36661 2.30573 4.83506L3.87495 6.49405C3.88129 6.50075 3.89194 6.50076 3.89829 6.49408L7.86893 2.31884C8.27075 1.89631 8.94577 1.9005 9.34231 2.32799V2.32799C9.71014 2.72452 9.70061 3.34034 9.32069 3.7253L3.96008 9.15693C3.91906 9.19848 3.85253 9.20016 3.80947 9.16073L0.779532 6.38612C0.345331 5.98851 0.305886 5.31775 0.690491 4.87199V4.87199Z'
      fill='#F5F5F5'
    />
  </svg>
);

export const IconXMark = ({ size }: any) => (
  <svg
    width={size ?? '10'}
    height={size ?? '10'}
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.42578 1.61719L8.92578 9.11719M1.42578 9.11719L8.92578 1.61719'
      stroke='white'
      strokeWidth='1.875'
    />
  </svg>
);

const CheckboxStyled = styled.div<{
  size?: string;
  x?: boolean;
  margin?: string;
  pointer?: boolean;
  checked?: boolean;
  checkColor?: string;
}>`
  width: ${({ size }) => size ?? '20'}px;
  height: ${({ size }) => size ?? '20'}px;
  border-radius: 2px;
  background-color: ${({ theme, x }) => (x ? theme.gray : theme.primary)};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${({ theme, x }) => (x ? theme.grey : theme.primary)};
  flex: none;
  /* margin-top: 10px; */
  ${({ margin }) => margin && `margin:${margin}`};
  ${({ pointer }) => pointer && `cursor: pointer`};

  ${({ checkColor }) =>
    checkColor &&
    `
  
  background: ${checkColor};
  border-color: ${checkColor};
  
  `};

  ${({ checked }) =>
    !checked &&
    `
    background-color: rgba(0,0,0,0);
`}
`;

interface CheckboxProps {
  onClick?: any;
  checked: boolean;
  size?: string;
  margin?: string;
  x?: boolean;
  pointer?: boolean;
  checkColor?: string;
}

const AnimatePresenceFixedType = AnimatePresence as ElementType;

export const Checkbox = ({
  onClick,
  checked,
  size,
  margin,
  x,
  pointer,
  checkColor,
}: CheckboxProps) => {
  return (
    <CheckboxStyled
      x={x}
      onClick={onClick}
      margin={margin}
      size={size}
      checked={checked}
      pointer={pointer}
      checkColor={checkColor}
    >
      <AnimatePresenceFixedType mode='wait'>
        {!x && checked ? (
          <motion.div
            key={1}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            initial={{ opacity: 0, transform: 'scale(0)' }}
            animate={{ opacity: 1, transform: 'scale(1)' }}
            exit={{ opacity: 0, transform: 'scale(0)' }}
            transition={{
              duration: 0.2,
            }}
          >
            <IconCheckMark size={`${size ? Number(size) / 2 : 24 / 2}`} />
          </motion.div>
        ) : (
          <></>
        )}
      </AnimatePresenceFixedType>
      {x && <IconXMark />}
    </CheckboxStyled>
  );
};
